/**
 * LOVELOOP – Tap-Vorschau für Produktkarten auf Touch-Geräten.
 * 1. Tipp auf das Produktbild: zeigt das zweite Produktbild.
 * 2. Tipp auf dasselbe Bild: öffnet die Produktseite.
 * Desktop (Maus) bleibt unverändert.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;

  /** @type {HTMLElement | null} */
  var activeCard = null;

  function getSlideshow(card) {
    return (card.refs && card.refs.slideshow) || card.querySelector('slideshow-component');
  }

  function visibleSlideCount(slideshow) {
    var slides = (slideshow.refs && slideshow.refs.slides) || slideshow.querySelectorAll('slideshow-slide');
    var count = 0;
    for (var i = 0; i < slides.length; i++) {
      if (!slides[i].hidden) count++;
    }
    return count;
  }

  function resetCard(card) {
    if (!card) return;
    card.removeAttribute('data-tap-previewed');
    var slideshow = getSlideshow(card);
    try {
      if (slideshow && typeof slideshow.select === 'function') {
        slideshow.select(0, undefined, { animate: false });
      }
    } catch (e) {}
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var gallery = target.closest('product-card .card-gallery');
      if (!gallery) {
        // Tipp außerhalb einer Karte setzt die zuletzt aktive Karte zurück
        if (activeCard && !activeCard.contains(target)) {
          resetCard(activeCard);
          activeCard = null;
        }
        return;
      }

      // Pfeile, Buttons, Swatches usw. normal funktionieren lassen
      if (target.closest('button, input, label, select, .slideshow-control')) return;

      var card = gallery.closest('product-card');
      if (!card) return;

      var slideshow = getSlideshow(card);
      if (!slideshow || typeof slideshow.next !== 'function') return;
      if (visibleSlideCount(slideshow) < 2) return; // nur ein Bild -> direkt öffnen

      if (card.hasAttribute('data-tap-previewed')) {
        // 2. Tipp: vor dem Seitenwechsel aufs erste Bild zurück, damit der
        // Seitenübergang und die Rückkehr (Zurück-Button) sauber funktionieren
        resetCard(card);
        activeCard = null;
        return; // normal navigieren
      }
      if (typeof slideshow.current === 'number' && slideshow.current > 0) return; // schon weitergewischt

      // 1. Tipp: Navigation verhindern und zweites Bild zeigen
      event.preventDefault();
      event.stopPropagation();

      if (activeCard && activeCard !== card) resetCard(activeCard);

      try {
        slideshow.next(undefined, { animate: false });
      } catch (e) {
        return;
      }
      card.setAttribute('data-tap-previewed', '');
      activeCard = card;
    },
    true
  );

  // Zurück-Button (Safari/iOS stellt die Seite aus dem Cache wieder her):
  // alle Karten zurücksetzen und hängengebliebene Übergangs-Zustände entfernen
  function restoreCards() {
    activeCard = null;
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].hasAttribute('data-tap-previewed')) resetCard(cards[i]);
    }
    var galleries = document.querySelectorAll('[data-view-transition-triggered], [data-view-transition-type]');
    for (var j = 0; j < galleries.length; j++) {
      galleries[j].removeAttribute('data-view-transition-triggered');
      galleries[j].removeAttribute('data-view-transition-type');
    }
    var imgs = document.querySelectorAll('product-card .card-gallery img');
    for (var k = 0; k < imgs.length; k++) {
      var img = imgs[k];
      img.style.removeProperty('view-transition-name');
      if (img.getAnimations) {
        var anims = img.getAnimations();
        for (var a = 0; a < anims.length; a++) anims[a].cancel();
      }
      if (img.complete && img.naturalWidth === 0) {
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', src);
      }
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) restoreCards();
  });
  window.addEventListener('pagehide', function () {
    activeCard = null;
  });
})();
